<template>
  <div class="flex h-screen overflow-hidden bg-primary">
    <!-- Desktop Sidebar -->
    <HeroSideBar class="hidden md:flex md:flex-col h-full" @sub-selected="onSubSelected" />

    <div class="flex-1 flex flex-col overflow-hidden">

      <!-- Mobile Navbar -->
      <div class="md:hidden flex items-center justify-between px-4 py-3 bg-[#D7642A] text-white">
        <div class="flex items-center gap-2">
          <img src="@/assets/iwc_logo.png" alt="Logo" class="w-8 h-8 object-contain" />
          <span class="font-semibold text-lg">IWC Gazette CMS</span>
        </div>
        <button @click="toggleMobileSidebar" class="p-2 focus:outline-none">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"
            stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      <!-- Mobile Sidebar Overlay -->
      <transition name="fade">
        <div v-if="mobileSidebarOpen" class="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
          @click="mobileSidebarOpen = false"></div>
      </transition>

      <!-- Mobile Sidebar -->
      <transition name="slide">
        <div v-if="mobileSidebarOpen" class="fixed inset-y-0 left-0 w-64 z-50 md:hidden">
          <HeroSideBar @sub-selected="onSubSelected" />
        </div>
      </transition>

      <!-- Main Content -->
      <HeroSubHeader class="px-5 shrink-0" :title="subHeader.title" :description="subHeader.description" />
      <hr class="mb-3 h-1 bg-subheader-line mx-5 shrink-0" />

      <div class="flex-1 overflow-y-auto px-5">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import HeroSideBar from "@/components/common/HeroSideBar.vue";
import HeroSubHeader from "@/components/common/HeroSubHeader.vue";

export default {
  components: {
    HeroSideBar,
    HeroSubHeader,
  },
  setup() {
    const subHeader = reactive({ title: "", description: "" });
    const mobileSidebarOpen = ref(false);

    const onSubSelected = (payload) => {
      subHeader.title = payload.title;
      subHeader.description = payload.description;
    };

    const toggleMobileSidebar = () => {
      mobileSidebarOpen.value = true;
    };

    return { subHeader, onSubSelected, mobileSidebarOpen, toggleMobileSidebar };
  },
};
</script>

<style scoped>
/* Smooth fade for overlay */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Slide in/out sidebar */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>